import { useEffect, useState } from 'react'
import { Divider, Grid } from '@material-ui/core'
import SnackBar from 'shared/components/SnackBar'
import Text from 'shared/components/Text'
import { useFrotista } from 'modules/user/hooks/useFrotista'

import { ITrazerDinheiroProps } from './TrazerDinheiroComponent.types'
import {
  Label,
  Container,
  ContainerBorder,
  LabelItem,
  TextItem,
  ContainerText,
  TextInfo,
  ContainerTabs,
} from './styles'
import Tabs from 'shared/components/Tabs'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import IContaEscrow from 'modules/pagamentos/domain/entities/IContaEscrow'
import { cnpjMask } from 'shared/utils/formatters'
import NovoBoleto from './components/NovoBoleto'
import GerenciarBoleto from './components/GerenciarBoleto'
import ContainerPage from 'shared/components/ContainerPage'
import CartaoNew from 'modules/pagamentos/pages/components/CartaoNew'
import { colors } from 'shared/styles/colors'

export const TrazerDinheiro: React.FC<ITrazerDinheiroProps> = ({
  gerarBoletoDeposito,
  baixarPdfBoletoDeposito,
  listaContaEscrow,
  listaBoletosDeposito,
}) => {
  const { frotistaId } = useFrotista()
  const [loading, setLoading] = useState(false)
  const [openErrorMessage, setOpenErrorMessage] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [activeMenu, setActiveMenu] = useState('Novo boleto')

  const [contaEscrow, setContaEscrow] = useState<IContaEscrow>()

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      try {
        const contasEscrow = await listaContaEscrow.execute(frotistaId)
        setContaEscrow(contasEscrow)
        setLoading(false)
      } catch (e: unknown) {
        if (e instanceof Error) {
          setErrorMessage(e.message || 'Erro ao atualizar os valores')
        } else {
          setErrorMessage('Erro ao atualizar os valores')
        }
        setOpenErrorMessage(true)
        setLoading(false)
      }
    }

    init()
  }, [])

  return (
    <ContainerPage
      breadCrumb="Pagamentos/Trazer dinheiro"
      showScaffold={true}
      showFooterScaffold={false}
      header={<CartaoNew />}
      backgroundColor={colors.grayExtraLight}
      boxShadow={'none'}
      padding={'0'}
    >
      <Container height={'auto'}>
        <Grid container>
          <Grid item>
            <Label>Trazer dinheiro</Label>
            <Text
              style={{
                paddingLeft: '32px',
                paddingBottom: '24px',
                marginTop: '-24px',
              }}
            >
              Agora é possível trazer dinheiro para sua conta Tmov Pay! Escolha
              entre depósito via boleto ou TED.
            </Text>
          </Grid>
        </Grid>
      </Container>

      <Grid container justifyContent="flex-start" spacing={3}>
        <Grid item xs={7}>
          <Container height={'100%'}>
            <Label>Boleto</Label>
            <Divider />
            <ContainerTabs>
              <Tabs>
                <Tabs.Item
                  onClick={() => {
                    setActiveMenu('Novo boleto')
                  }}
                  active={activeMenu === 'Novo boleto'}
                >
                  <span>Novo boleto</span>
                </Tabs.Item>
                <Tabs.Item
                  onClick={() => {
                    setActiveMenu('Gerenciar boleto')
                  }}
                  active={activeMenu === 'Gerenciar boleto'}
                >
                  <span>Gerenciar boleto</span>
                </Tabs.Item>
              </Tabs>
            </ContainerTabs>

            {activeMenu === 'Novo boleto' && (
              <NovoBoleto
                gerarBoletoDeposito={gerarBoletoDeposito}
                baixarPdfBoletoDeposito={baixarPdfBoletoDeposito}
              />
            )}
            {activeMenu === 'Gerenciar boleto' && (
              <GerenciarBoleto
                listaBoletosDeposito={listaBoletosDeposito}
                baixarPdfBoletoDeposito={baixarPdfBoletoDeposito}
              />
            )}
          </Container>
        </Grid>

        <Grid item xs={5}>
          <Container height={'100%'}>
            <Label>TED</Label>
            <Divider />
            <ContainerBorder>
              <LabelItem>Banco</LabelItem>
              <TextItem>
                {`${contaEscrow?.banco?.codigo || ''} - ${
                  contaEscrow?.banco?.nomeReduzido || ''
                }`}
              </TextItem>
              <Divider />
              <Grid container>
                <ContainerText>
                  <LabelItem>Agência</LabelItem>
                  <TextItem>{contaEscrow?.agencia}</TextItem>
                </ContainerText>
                <ContainerText>
                  <LabelItem>Conta Corrente</LabelItem>
                  <TextItem>{`${contaEscrow?.conta || ''}${
                    contaEscrow?.digito ? '-' : ''
                  }${contaEscrow?.digito || ''}`}</TextItem>
                </ContainerText>
              </Grid>

              <Divider />
              <LabelItem>CNPJ</LabelItem>
              <TextItem>{cnpjMask(contaEscrow?.cnpj || '')}</TextItem>
              <Divider />
              <LabelItem>Nome</LabelItem>
              <TextItem>{contaEscrow?.nome}</TextItem>
            </ContainerBorder>
            <TextInfo>A compensação ocorrerá em até 1 dia útil.</TextInfo>
            <TextInfo>
              Só é possível realizar TED a partir de conta conjunta quando o
              primeiro títular da conta for o mesmo titular da conta do Tmov
              Pay.
            </TextInfo>
          </Container>
        </Grid>
      </Grid>

      <SnackBar
        open={openErrorMessage}
        setOpen={setOpenErrorMessage}
        severity="error"
        message={errorMessage}
        horizontal="right"
      />
      <LoadingBackdrop open={loading} />
    </ContainerPage>
  )
}

export default TrazerDinheiro
